var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-tips-bar"},[_vm._v(" "+_vm._s(_vm.tipsText)+"，请"),_c('a',{on:{"click":function($event){$event.stopPropagation();return _vm.toMediaLogin.apply(null, arguments)}}},[_vm._v("点击此处")]),_vm._v("注册登录 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }